module.exports = __webpack_public_path__ + "static/media/ship_lime.33027264.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/ship_lime.png
// module id = 206
// module chunks = 0